import React from "react";

function VictozaBuilder(){

    const newFunction = () => {
        console.log("I want something logged here.")
    }

    const anotherFunction = () => {
        console.log("Wee!")
    }

    return(
        <div>Main: Victoza Builder</div>
    )
}

export default VictozaBuilder